import {Parser, ParseResult} from "./parser";
import {BlockMarkupItemType} from "../markup.interface";

const matcher = /\{image-(\d+)\}/;

export const imageParser: Parser = {
    matches(markup: string, startIndex: number): boolean {
        const match = markup.substring(startIndex).match(matcher);
        return match !== null && match.index === 0;
    },

    parse(markup: string, startIndex: number): ParseResult {
        const match = markup.substring(startIndex).match(matcher)!;

        return {
            item: {
                type: BlockMarkupItemType.Image,
                imageId: parseInt(match[1], 10),
            },
            lastIndex: startIndex + match[0].length,
        }
    }
}
